import { Navigate } from 'react-router-dom';
import { useContext } from '@/hooks/useContext';
import { PageSpinner } from '@/components/ui';
import { useContextStore } from '@/stores/context.store';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Smart redirect that routes users based on their role and context state
 * - Patients: always go to /patient/dashboard
 * - Other users:
 *   - If doctor is selected: go to /calendar
 *   - If only clinic is selected: go to /medicos
 *   - Otherwise: go to /clinicas
 */
export function SmartRedirect() {
  const { doctor, clinic } = useContext();
  const { isHydrated } = useContextStore();
  const { user } = useAuthStore();

  // Wait for context to be hydrated before deciding where to redirect
  if (!isHydrated) {
    return <PageSpinner label="Carregando..." />;
  }

  // If user is a patient, always redirect to patient dashboard
  if (user?.role === 'Paciente') {
    return <Navigate to="/patient/dashboard" replace />;
  }

  // If doctor is selected, go to calendar
  if (doctor) {
    return <Navigate to="/calendar" replace />;
  }

  // If only clinic is selected, go to doctor selection
  if (clinic) {
    return <Navigate to="/medicos" replace />;
  }

  // No context, go to clinic selection
  return <Navigate to="/clinicas" replace />;
}
